import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { UserService } from 'src/app/_services/user.service';
import Swal from 'sweetalert2';
import { User } from './../../../_models/user';
import { AuthService } from './../../../_services/auth.service';
@Component({
  selector: 'app-register-step-three-verify',
  templateUrl: './register-step-three-verify.component.html',
  styleUrls: ['./register-step-three-verify.component.css']
})
export class RegisterStepThreeVerifyComponent implements OnInit {
  newUserData:User= new User()
  form: FormGroup;
  loading = false;
  submitted = false;
  responseMessage = '';
  errorEncountered=false

  isRegistrationSuccess=false
  roles: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private router:Router,
    private userService:UserService,
    public authService:AuthService
    ) { }
    userMessage=""
    ngOnInit(): void {
    this.userService.registrationData.subscribe(
      x=>{
        console.log("new user data",x)
        this.newUserData=x
      }
    )

    this.userService.userMessage.subscribe(
      x=>{
        this.userMessage=x
      }
    )
    this.form = this.formBuilder.group({
      vcode: ['', Validators.compose([Validators.required,Validators.minLength(5)])],
     });
  }


  get f() { return this.form.controls; }

  onSubmit(): void {
      this.submitted = true;
      let d = this.userService.registrationData.getValue()
      console.log("new user datad",d)
      let myUser = new User()
      myUser.username=d['username']
      myUser.vcode=+this.form.value.vcode


        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.errorEncountered=false

      this.userService.verify(myUser).subscribe(
        { next:(rsData:ResultData) =>{

            let status =rsData['server_user_id']!=0
            this.loading=false
            if(status){

              this.router.navigate(['/user/new/step/verification/success'])
              this.isRegistrationSuccess=true
            }else{
              this.isRegistrationSuccess=false
              this.responseMessage=rsData['message']
              this.errorEncountered=true
              Swal.fire( 'Oops',rsData['message'],'info')
            }

          },
          error:(error)=>{
            this.loading=false
            this.responseMessage = error.error.message;
            this.isRegistrationSuccess=false
            this.errorEncountered=true
          }
        }
        )
  }
}
